import { FC, Fragment } from 'react';
import { Card, Flex, List } from 'antd';
import { PageName, useApp } from '@/App';
import CountUp from 'react-countup';
import { useThingsToDo } from '@/libs/fleet-api/services/things-todo';
import { useQuery } from '@tanstack/react-query';
import { getFSCustomers } from '@/libs/fleet-api/services/customer';

const FSThingsToDo: FC = () => {
	const { navigate } = useApp();
	const { data: todoData, isLoading } = useThingsToDo();
	const counts = todoData?.data;

	const customerListData = useQuery({
		queryKey: ['getCustomerList'] as const,
		queryFn: () => {
			return getFSCustomers({});
		},
	});

	const data = [
		{
			title: 'Verifikasi Data Referral JF',
			count: customerListData.data?.data?.totalCount ?? 0,
			link: 'FSCustomerListPage',
		},
		{
			title: 'Monitoring Pipeline Golive',
			count: counts?.pipelineGoLive ?? 0,
			link: 'GoliveListPage',
		},
	];

	return (
		<Fragment>
			<List
				loading={isLoading}
				grid={{ gutter: 20, column: 2 }}
				dataSource={data}
				renderItem={(item) => {
					return (
						<List.Item style={{ marginBottom: 20 }}>
							<Card
								hoverable
								size="small"
								style={{ borderRadius: 0 }}
								onClick={() => {
									navigate(item.link as PageName);
								}}
							>
								<Flex
									justify="space-between"
									align="center"
								>
									{item.title}
									<div
										className={`badge-todo ${item.count > 0 ? 'badge-active' : ''}`}
									>
										<CountUp end={item.count} />
									</div>
								</Flex>
							</Card>
						</List.Item>
					);
				}}
			/>
		</Fragment>
	);
};

export default FSThingsToDo;
